<template>
	<div style="flex: 1; background-color: #f8f9fa; margin-top: 5px; overflow-x: hidden; overflow-y: auto">
		<pivot class="sa-pivot-edit" ref="cmpPivotData" cols-label-text="Trascina i campi qui per le colonne" rows-label-text="Righe" :key="pivotKey" :data="pivotData" v-model="pivotFields" :showSettings="defaultShowSettings" />
	</div>
</template>

<script>
import { Pivot } from "vue-pivot-table-plus";
import UtilityMixin from "../../utility/UtilityMixin";
export default {
	mixins: [UtilityMixin],
	components: { Pivot },
	data() {
		return {
			//id: "ec0ab16a-2bce-43c0-a9f8-061d638b4968",
			id: null,
			idQuery: null,
			pathResourceData: "/dataanalysisdatabaseinfo/eseguianaliticquery",
			pivotKey: 0,
			dashboardParams: {},
			pivotParams: { fieldsParam: [] },
			pivotData: [],
			defaultShowSettings: true,
			pivotFields: {
				availableFields: [],
				rowFields: [],
				colFields: [],
				fieldsOrder: {},
			},
			reportJson: {
				dataSource: { data: [] },
				slice: {
					rows: [],
					columns: [],
					measures: [],
				},
				localization: "lang/pivottable/it.json",
			},
			customizeToolbar: (toolbar) => {
				// Get all tabs from the Toolbar
				let tabs = toolbar.getTabs();
				if (tabs.length > 0) {
					// Delete the Connect tab
					tabs = tabs.filter((tab) => tab.id !== "wdr-tab-connect");
					tabs = tabs.filter((tab) => tab.id !== "wdr-tab-fullscreen");
					tabs = tabs.filter((tab) => tab.id !== "wdr-tab-open");
					tabs = tabs.filter((tab) => tab.id !== "wdr-tab-options");
					tabs = tabs.filter((tab) => tab.id !== "wdr-tab-save");
					tabs = tabs.filter((tab) => tab.id !== "wdr-tab-format");
				}
				toolbar.getTabs = () => tabs;
			},
		};
	},
	methods: {
		init(chartParams) {
			let me = this;
			me.idQuery = chartParams.idQuery;
			me.pivotParams = chartParams.pivotParams ? JSON.parse(JSON.stringify(chartParams.pivotParams)) : { fieldsParam: [] };
			me.reportJson.slice = me.pivotParams.slice ? me.pivotParams.slice : { rows: [], columns: [], measures: [] };
			if (!this.pivotParams.pivotFields) {
				this.pivotParams.pivotFields = {
					availableFields: [],
					rowFields: [],
					colFields: [],
					fieldsOrder: {},
				};
			} else {
				this.setPivotParams();
			}
			me.loadData();
		},
		loadData() {
			let me = this;
			me.loadDataResources(me.pathResourceData + "/" + me.idQuery, {}, me.loadDataSuccess, me.loadDataError);
		},
		loadDataSuccess(response) {
			let me = this;
			me.resultData = response.data.data;
			me.reportJson.dataSource.data = response.data.data;
			if (me.reportJson.dataSource.data.length > 0) {
				if (me.pivotParams.fieldsParam.length === 0) {
					let record = me.reportJson.dataSource.data[0];
					for (var key of Object.keys(record)) {
						me.pivotParams.fieldsParam.push({ uniqueName: key, caption: key, type: "string" });
					}
				} else {
					//me.reportJson.dataSource.data.unshift(me.getDataConfig());
				}
			}
			this.eleboraDati();
			me.pivotKey++;
			this.$emit("afterLoadData");
		},
		loadDataError(error) {
			console.log(error);
		},
		onDowloadFileCsv() {
			this.$refs.cmpPivotData.downloadPivotTableData("csv");
		},

		getDataConfig() {
			let me = this;
			let dataConfig = {};
			for (var field of me.pivotParams.fieldsParam) {
				dataConfig[field.uniqueName] = { type: field.type, caption: field.caption };
			}

			return dataConfig;
		},
		onReportComplete() {},
		/*parte da mettere nel mixinis*/
		eleboraDati() {
			this.pivotData = [];
			let dataTimeFields = this.pivotParams.fieldsParam.filter((field) => field.type === "timestamp");
			this.resultData.forEach((row) => {
				dataTimeFields.forEach((fieldParam) => {
					let dataOra = new Date(row[fieldParam.uniqueName]);
					let year = dataOra.getFullYear();
					let month = dataOra.getMonth() + 1;
					let dayOfWeek = dataOra.getDay();
					let day = dataOra.getDate();
					var quarter = Math.floor((dataOra.getMonth() + 3) / 3);
					let year_key = fieldParam.uniqueName + "_year";
					row[year_key] = year;
					let month_key = fieldParam.uniqueName + "_month";
					row[month_key] = month;
					let day_key = fieldParam.uniqueName + "_day";
					row[day_key] = day;
					let quarter_key = fieldParam.uniqueName + "_quarter";
					row[quarter_key] = quarter;
					let day_week_key = fieldParam.uniqueName + "_day_week";
					row[day_week_key] = UtilityMixin.methods.getDayOfWeek((dayOfWeek + 1).toString());
				});
				this.pivotData.push(row);
			});
		},
		setPivotParams() {
			this.pivotParams.pivotFields.availableFields.forEach((pivotField) => {
				this.pivotFields.availableFields.push({ getter: (item) => item[pivotField.key], label: pivotField.label, key: pivotField.key });
			});
			this.pivotParams.pivotFields.colFields.forEach((pivotField) => {
				this.pivotFields.colFields.push({ getter: (item) => item[pivotField.key], label: pivotField.label, key: pivotField.key });
			});
			this.pivotParams.pivotFields.rowFields.forEach((pivotField) => {
				this.pivotFields.rowFields.push({ getter: (item) => item[pivotField.key], label: pivotField.label, key: pivotField.key });
			});
			this.pivotKey++;
		},
	},
};
</script>

<style></style>
